import * as React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { getConfig } from '@cian/config/browser';
import { getLogger } from '@cian/logger/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { TReduxStore } from '../../../shared/types/redux';
import { Application } from '../../../shared/containers/App';
import { ICustomContextParams } from '../../../shared/types/ICustomContextParams';
import { IApplicationContext } from '../../../shared/types/application';

interface IDependencies {
  store: TReduxStore;
  context: IApplicationContext;
}

export function renderApplication(dependencies: IDependencies) {
  const config = getConfig();
  const { store } = dependencies;

  const projectName = config.getStrict<string>('projectName');
  const customContext = config.getStrict<ICustomContextParams>('applicationContext.custom');
  const rootElement = document.getElementById(projectName as string);

  if (!rootElement) {
    throw new Error(`Unable to find element #${projectName}`);
  }

  hydrateRoot(
    rootElement,
    <Application
      config={config}
      logger={getLogger()}
      httpApi={getHttpApi()}
      reduxStore={store}
      customContext={customContext}
    />,
  );
}
